import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTradeTermList(params) {
  return request({
    url: URL.mdm.basicData.tradeTerm,
    method: 'get',
    params
  })
}

export function getTradeTermsByPlatform(params) {
  return request({
    url: URL.sys.platformTradeTerm,
    method: 'get',
    params
  })
}

export function getAllTradeTermTemplate(params) {
  return request({
    url: URL.mdm.basicData.tradeTermTemplate,
    method: 'get',
    params
  })
}

export function saveTradeTerm(data) {
  return request({
    url: URL.mdm.basicData.tradeTerm,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addTradeTermByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformTradeTerm,
    method: 'post',
    data
  })
}

export function saveTradeTerms(data) {
  return request({
    url: URL.mdm.basicData.tradeTerms,
    method: 'post',
    data
  })
}

export function delTradeTerm(uuid) {
  return request({
    url: URL.mdm.basicData.tradeTerm + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
